import { api } from '@api/client'
import { cached, makeKey, TWELVE_HOURS_MS } from '@cache/requestCache'

export function getSites (comapnyId) {
  const url = `/company/${comapnyId}/sites`
  const key = makeKey(url, {})

  return cached(
    key,
    async () => {
      const response = await api.get(url)
      return response.data
    },
    TWELVE_HOURS_MS
  )
}
